// extracted by mini-css-extract-plugin
export var fullHeightState = "_40-7";
export var headerCell = "_40-1";
export var loadingStateCell = "_40-4";
export var rowWrapper = "_40-3";
export var standaloneTable = "_40-8";
export var standaloneTableWithBodyFill = "_40-9";
export var stateCell = "_40-5";
export var table = "_40-0";
export var tableBodyFiller = "_40-6";
export var white = "_40-2";